import React from 'react'
import { Loader } from 'stylist'
import CurrentUser from 'components/CurrentUser'
import normalizeHostname from 'utils/normalizeHostname'
import Location from 'components/Location'
import { Redirect } from 'react-router-dom'

const AuthenticatedProductServerRedirect = ({ clientId }) => (
  <CurrentUser
    render={({ loading, viewer }) => {
      if (loading) {
        return <Loader data-testid="loader" size="lg" centered />
      }
      const servers =
        viewer && viewer.userServers && viewer.userServers(clientId)
      if (servers && servers.length === 1) {
        return (
          <Location to={normalizeHostname(servers[0].hostname, clientId)} />
        )
      }
      return <Redirect to="/" />
    }}
  />
)

export default AuthenticatedProductServerRedirect



// WEBPACK FOOTER //
// ./src/components/AuthenticatedRedirect/AuthenticatedProductServerRedirect.js